"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import vueQr from "vue-qr";
let WxReg = class extends Vue {
  constructor() {
    super(...arguments);
    this.qrCode = "";
    this.qrLoading = true;
    this.imageUrl = require("../../../assets/logo-64.png");
    this.iconShow = true;
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.getWxRegisterLink();
    });
  }
  beforeDestroy() {
    return __async(this, null, function* () {
    });
  }
  getWxRegisterLink() {
    return __async(this, null, function* () {
      try {
        this.qrLoading = true;
        const response = yield API.get("api://base/api/v7/wechat/drainage/registerLink");
        this.qrCode = response.data.link;
      } catch (error) {
        console.dir(error);
      } finally {
        this.qrLoading = false;
      }
    });
  }
};
WxReg = __decorateClass([
  Component({
    components: {
      vueQr
    }
  })
], WxReg);
export {
  WxReg as default
};
